import { render, staticRenderFns } from "./ShopCrownTabe.vue?vue&type=template&id=59657d32&scoped=true&"
import script from "./ShopCrownTabe.vue?vue&type=script&lang=js&"
export * from "./ShopCrownTabe.vue?vue&type=script&lang=js&"
import style0 from "./ShopCrownTabe.vue?vue&type=style&index=0&id=59657d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59657d32",
  null
  
)

export default component.exports